import { CountryISO } from "ngx-intl-tel-input";

export default (): CountryISO => {
    const countryData = JSON.parse(
        document.getElementById('country-data')?.textContent || '{}'
    );

    return countryData.country ?? CountryISO.Nigeria; // e.g. "ng"
}